export default function buildFontString(element) {
    const fonts = [];
    const { style, heading } = element;
    if (style) fonts.push({ style });
    if (heading) fonts.push(...Object.values(heading));
    return fonts
        .reduce(fontReducer, [])
        .map((font) => {
            let fontString = '';
            if (font.fontFamily) {
                fontString += plusify(font.fontFamily);

                if (font.fontWeights.length) {
                    fontString += `:${font.fontWeights.join(',')}`;
                }
            }
            return fontString;
        })
        .filter((v) => v)
        .join('|');
}

function plusify(str) {
    return str.replace(/\s/g, '+');
}

function fontReducer(acc, next) {
    const { fontFamily = '', fontWeight = '' } = next.style;
    const found = acc.find((font) => font.fontFamily === fontFamily);
    if (!found) {
        const fontWeights = [];
        fontWeight && fontWeights.push(fontWeight);
        return acc.concat({ fontFamily, fontWeights });
    } else {
        fontWeight && found.fontWeights.push(fontWeight);
        return acc;
    }
}
